import { ChangeDetectionStrategy, Component, forwardRef, Input } from '@angular/core';
import { ProductSectionHeaderComponent } from '../product-section-header/product-section-header.component';

@Component({
  selector: 'app-expanded-product-section-header',
  templateUrl: './expanded-product-section-header.component.html',
  styleUrl: './expanded-product-section-header.component.scss',
  providers: [
    { provide: ProductSectionHeaderComponent, useExisting: forwardRef(() => ExpandedProductSectionHeaderComponent) }
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class ExpandedProductSectionHeaderComponent extends ProductSectionHeaderComponent {
  @Input() ignoreUserSetTextColorAndAutoToLightOrDarkTextColor: boolean = false;
}
